App.OrganizationSelectModalComponent = Em.Component.extend
  actions:
    closeModal: ->
      @sendAction 'onCloseModal'
      false

    organizationSelected: (organization) ->
      @sendAction 'onOrganizationSelect', organization
      false